(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["menu.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<header>\r\n\t<div class=\"share\">\r\n\t\t<a href=\"https://www.facebook.com/sharer/sharer.php?u=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"link")), env.opts.autoescape);
output += "&t=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"facebook")),"name")), env.opts.autoescape);
output += "\" title=\"Partager sur Facebook\" target=\"_blank\" class=\"fb\">\r\n\t\t\t<img src=\"/img/facebook.svg\" alt=\"Partager sur Facebook\">\r\n\t\t</a>\r\n\t\t<a href=\"https://twitter.com/intent/tweet?source=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"link")), env.opts.autoescape);
output += "&text=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"twitter")), env.opts.autoescape);
output += "\" title=\"Tweet\" target=\"_blank\" class=\"tw\">\r\n\t\t\t<img src=\"/img/twitter.svg\" alt=\"Twitter\" />\r\n\t\t</a>\r\n\t\t<a href=\"mailto:?subject=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"email")),"subject")), env.opts.autoescape);
output += "&amp;body=";
output += runtime.suppressValue(env.getFilter("urlencode").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"share")),"general_share")),"email")),"content")), env.opts.autoescape);
output += "\" title=\"Envoyer par email\" class=\"mail\">\r\n\t\t\t<img src=\"/img/mail.svg\" alt=\"Envoyer par email\">\r\n\t\t</a>\r\n\t\t<a href=\"/print.php\" target=\"cursusprint\" title=\"Imprimer les résultats\" class=\"print\">\r\n\t\t\t<img src=\"/img/print.svg\" alt=\"Imprimer les résultats\">\r\n                </a> \r\n\t\t<a href=\"/print_questions.php\" target=\"cursusprint\" title=\"Imprimer mes réponses\" class=\"print\">\r\n\t\t\t<img src=\"/img/print_questions.svg\" alt=\"Imprimer mes réponses\">\r\n                </a> \r\n\t</div>\r\n\t<!-- print -->\r\n\t<div class=\"btn-close\"></div>\r\n</header>\r\n\r\n<div class=\"myResult\">\r\n\t";
if(0 && runtime.contextOrFrameLookup(context, frame, "bestDomain")) {
output += "\r\n\t\t<h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"title"), env.opts.autoescape);
output += "</h3>\r\n\t\t<span class=\"note\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"high_score"), env.opts.autoescape);
output += "</span>\r\n\t\t<h4><span data-domain>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "bestDomain")),"nom"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "bestDomain")),"prc"), env.opts.autoescape);
output += "%</span> <i class=\"icn-domaine-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "bestDomain")),"slug"), env.opts.autoescape);
output += "\"></i></h4>\r\n\t";
;
}
output += "\r\n\r\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"isLoggedIn")) {
output += "\r\n\t<strong>Mon compte</strong>\r\n\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"hi"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"prenom"), env.opts.autoescape);
output += ", <br> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"follow_scores"), env.opts.autoescape);
output += "</p>\r\n                <p><a href=\"/users/logout?hash=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"sessionhash"), env.opts.autoescape);
output += "\">&rarr; Je me déconnecte de la session en cours</a><br/><a href=\"/users/remove?hash=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"sessionhash"), env.opts.autoescape);
output += "\">&rarr; Je me désinscris d'Ada-intérêts (et mes résultats sont supprimés)</a></p>\r\n\t";
;
}
else {
output += "\r\n\t\t<p>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"home")),"description")), env.opts.autoescape);
output += "</p>\r\n\t";
;
}
output += "\r\n        ";
if(runtime.contextOrFrameLookup(context, frame, "bestDomain")) {
output += "\r\n\t<strong>Mes résultats</strong>\r\n\t<p><a href=\"/print.php\" target=\"cursusprint\">&rarr; Visualiser ou imprimer mes résultats</a></p>\r\n\t<p><a href=\"/print_questions.php\" target=\"cursusprint\">&rarr; Visualiser ou imprimer le récapitulatif de mes réponses</a></p>\r\n        ";
;
}
output += "\r\n</div>\r\n\r\n<div class=\"menu-result\">\r\n\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "domains");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("domain", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t<div class=\"domain_";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += " menu-domain\">\r\n\t\t\t<div class=\"domain-name\">\r\n\t\t\t\t<div class=\"progress\" style=\"width:";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%\"></div>\r\n\t\t\t\t<div class=\"text\">\r\n\t\t\t\t\t<span class=\"num\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"letter"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t<span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"nom"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t<span class=\"percent\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t";
if(runtime.memberLookup((t_4),"families")) {
output += "\r\n\t\t\t\t<div class=\"result\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"families");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("family", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n\t\t\t\t\t\t<div class=\"family-name\" data-family-cta=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" data-domain-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"progress\" style=\"width:";
output += runtime.suppressValue(runtime.memberLookup((t_8),"prc"), env.opts.autoescape);
output += "%;\"></div>\r\n\t\t\t\t\t\t\t<div class=\"text button-icn\">\r\n\t\t\t\t\t\t\t\t<h6>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"prc"), env.opts.autoescape);
output += "%</h6><i class=\"icn-fleche-droite-cercle\"></i>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t<div class=\"no-result\">\r\n\t\t\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"no_result")),"title"), env.opts.autoescape);
output += "</p>\r\n\t\t\t\t\t<div class=\"button-flat\" data-domain-quiz-cta data-domain-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"menu")),"no_result")),"cta"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\t\t</div>\r\n\t";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t<div class=\"footer\">\r\n\t\t<a class=\"footer-logo\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"global")),"udem_link"), env.opts.autoescape);
output += "\" target=\"_blank\"></a>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
